import { render } from "./KidsProductDetail.vue?vue&type=template&id=29659b14&scoped=true"
import script from "./KidsProductDetail.vue?vue&type=script&lang=js"
export * from "./KidsProductDetail.vue?vue&type=script&lang=js"

import "./KidsProductDetail.vue?vue&type=style&index=0&id=29659b14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29659b14"]])

export default __exports__